import CircularProgress from "@mui/material/CircularProgress";

interface WidgetTileProps {
    title: string;
    showLoading: boolean;
}

const WidgetTile = (props: WidgetTileProps) => {

    const { title, showLoading } = props;

    return (
        <div className="widget-title">
            <h4>{title}</h4>
            {
                showLoading && (
                    <CircularProgress
                        size={20}
                        thickness={6}
                        className="widget-progress" />
                )
            }
        </div>
    )
}

export default WidgetTile;
